"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useState } from "react";

const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);

  return (
    <div
      id="home"
      className="flex justify-between items-center relative px-5 md:px-12 py-2 bg-[#f7f3e9] shadow-md "
    >
      {/* Logo */}
      <Image
        src="/assets/logo-ramayana.png"
        alt="ramayana-logo"
        height={50}
        width={70}
        priority={true}
        className="rounded-full border-2 border-[#d4af37] bg-[#f7f3e9] "
      />

      <button
        onClick={() => setIsNavOpen(!isNavOpen)}
        className="w-10 h-10 md:hidden font-bold z-10 top-6 right-4 absolute hover:cursor-pointer"
      >
        ☰
      </button>
      {/* Nav Links */}
      <div
        className={`${
          isNavOpen
            ? "absolute top-0 z-0  transform translate-x-4 right-3 w-[60vw] h-[30vh] bg-gray-200 rounded-xl flex flex-col justify-center items-center gap-6 shadow-lg md:hidden"
            : "md:flex flex-row gap-6 text-lg font-semibold hidden"
        }`}
      >
        <Link
          href="#origins"
          className="text-[#1e3a8a] hover:text-[#d97706] hover:underline transition-colors duration-300 "
        >
          Origins
        </Link>
        <Link
          href="#chronicle"
          className="text-[#1e3a8a] hover:text-[#d97706] hover:underline transition-colors duration-300"
        >
          Chronicle
        </Link>
        <Link
          href="#geography"
          className="text-[#1e3a8a] hover:text-[#d97706] hover:underline transition-colors duration-300 "
        >
          Geography
        </Link>
        <Link
          href="#contact"
          className="text-[#1e3a8a] hover:text-[#d97706] hover:underline transition-colors duration-300"
        >
          Contact
        </Link>
      </div>
    </div>
  );
};

export default Navbar;
